import Vue from "vue";

export default (query, props) => {
  return Vue.$http.get("catalogs/services/supplies-search/", {
    params: { ...query },
    ...props,
  });
};



// WEBPACK FOOTER //
// ./src/services/purchase/getSupplyToAddToConcept.js